export const ScreenSize = {
    Small: "767px",
    Medium: "1000px",
    Large: "1200px",
    ExtraLarge: "1900px"
};
